export default "__VITE_ASSET__b168d0f6__"